const AdBanner = ({ type, className }) => {
  return null;
};

export default AdBanner;
